export const GOOGLE_MAP_ID = 'GOOGLE_MAP_ID';